const isGivenName = e => e['#name'] === 'given-name';
const isSurname = e => e['#name'] === 'surname';
const isSuffix = e => e['#name'] === 'suffix';

function filterProperties(e) {
  return isGivenName(e) || isSurname(e) || isSuffix(e);
}

function getFullName({ $$ }) {
  return $$
    .filter(filterProperties)
    .map((el) => {
      const [, val] = Object.values(el);
      return val;
    })
    .join(' ');
}

export default function parseAuthors({ authors }) {
  const authorsGroup = authors.$$ ? authors.$$.find(el => el['#name'] === 'author-group').$$ : [];
  return authorsGroup
    .filter(el => el['#name'] === 'author')
    .map(getFullName);
}
